const isDev = (process.env.VUE_APP_ENV || "dev") !== "production";

const noop = () => {};

export const log = isDev ? console.log.bind(console) : noop;
export const warn = isDev ? console.warn.bind(console) : noop;
export const debug = isDev ? console.debug.bind(console) : noop;

export const error = console.error.bind(console);
